import { ValidateJSModel } from 'forms/shared/types';
import { HeightModel } from 'forms/sections/identification/physical/types';

const heightModelValidator: ValidateJSModel<HeightModel> = {
  feet: {
    presence: true,
    numericality: {
      onlyInteger: true,
      greaterThanOrEqualTo: 1,
      lessThanOrEqualTo: 9,
      notGreaterThanOrEqualTo: 'error.height.feet.min',
      notLessThanOrEqualTo: 'error.height.feet.max',
      notInteger: 'error.height.feet.pattern',
    },
  },
  inches: {
    presence: true,
    numericality: {
      onlyInteger: true,
      greaterThanOrEqualTo: 0,
      lessThanOrEqualTo: 11,
      notGreaterThanOrEqualTo: 'error.height.inches.min',
      notLessThanOrEqualTo: 'error.height.inches.max',
      notInteger: 'error.height.inches.pattern',
    },
  },
};

export default heightModelValidator;
